import { useMemo } from "react";

import { queryGetUserAppAccessRight } from "@type/api/management";
import { useBusinessUnitStore } from "@type/store";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { TGetUserAppAccessRightReq } from "@type/api/management/types";
import { TBooleanRecord } from "types/index";
import { combineOpsNaviACRWithPrefix } from "constants/accessRight";

interface UseGetEmployeeAppAccessProps {
  params?: TGetUserAppAccessRightReq;
}

export const useGetEmployeeAppAccess = ({
  params,
}: UseGetEmployeeAppAccessProps) => {
  const queryGetUserAppAccessRightKey = useMemo(() => {
    return queryGetUserAppAccessRight._key(params);
  }, [params]);

  const onSetBUAppAccessRight = useBusinessUnitStore(
    (state) => state.onSetBUAppAccessRight
  );

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetUserAppAccessRightKey,
    enabled: !!params?.idBu && !!params.data?.idUser,
    queryFn: () => queryGetUserAppAccessRight(params),
    onSuccess: (res) => {
      const objAccess: TBooleanRecord = {};
      for (const access of res.data.access) {
        objAccess[combineOpsNaviACRWithPrefix(access.id)] = !!access.status;
        for (const subAccess of access?.sub || []) {
          objAccess[combineOpsNaviACRWithPrefix(subAccess.id)] =
            !!subAccess.status;
        }
      }
      onSetBUAppAccessRight(objAccess);
    },
  });

  return {
    isLoadingUserAppAccessRight: isLoading,
  };
};
